var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--gray-40)",
    viewBox: "0 0 64 64",
    className: "svg-icon",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8 8.547h36.774c0 .028.026.054.026.054h-.016a6.75 6.75 0 0 0-6.384 6.586v33.04l-.002-.02a6.8 6.8 0 0 1-6.786 7.246 6.8 6.8 0 0 1-6.786-7.226v-3.094H16V15.347a6.8 6.8 0 0 1 6.8-6.8Zm-.828 27.894h15.494v-4.64H21.972v4.64Zm.002-12.4h24.8v-4.64h-24.8v4.64Zm38.052-13.574h-.052A3.974 3.974 0 0 0 56 14.441v6.426h8v-6.426a3.974 3.974 0 0 0-3.974-3.974ZM36.8 48.257H0a6.8 6.8 0 0 0 6.8 6.8h34.026c-2.694 0-4.026-3.04-4.026-6.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameInfo);
export default __webpack_public_path__ + "static/media/game-info.7f8f3cbf624148735a668990d5851629.svg";
export { ForwardRef as ReactComponent };